import { breakpoints } from '@src/constants/breakpoints'
import { css, styled } from 'styled-components'

export const CheckoutRewardsContainer = styled.div<{ isBasket: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: rgba(246, 246, 249, 1);
  border-radius: 10px;

  ${({ isBasket }) =>
    isBasket
      ? css`
          padding: 16px 16px 0 16px;
        `
      : css`
          padding: 16px 8px 0 8px;
        `}
`
export const IconTextAndDetailsContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  width: 100%;
  min-height: 40px;
  margin-bottom: 8px;
  @media (max-width: ${breakpoints.largeMobile}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`
export const TextAndIconContainer = styled.div<{ isAddOnWarning?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
`

export const RewardNameContainer = styled.div<{
  color: string
  isAddOnWarning?: boolean
}>`
  margin-left: 12px;
  margin-right: 4px;
  color: ${({ color, theme }) =>
    color === 'discount'
      ? theme.colors.discount
      : color === 'addOn'
      ? theme.colors.brand
      : color};
  font-size: 14px;

  ${({ isAddOnWarning }) =>
    !isAddOnWarning
      ? css`
          font-weight: 700;
        `
      : css`
          @media (max-width: ${breakpoints.tablet}px) {
            max-width: 80%;
          }
        `}
`

export const EarningContainer = styled.div`
  margin-right: 8px;
  font-size: 14px;
  color: #2e3333;
  white-space: nowrap;

  @media (max-width: ${breakpoints.largeMobile}px) {
    font-size: 13px;
  }
`

export const ExtraInfoAndAmountEarnedContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 32px;
  align-items: center;
  justify-content: flex-end;
  margin-left: 0px;

  @media (max-width: ${breakpoints.largeMobile}px) {
    margin-left: 44px;
  }
`

export const DiscountIcon = styled.div`
  min-width: 32px;
  min-height: 32px;
  max-width: 32px;
  max-height: 32px;

  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.discount};
  align-items: center;
  justify-content: center;
  display: flex;
`

export const DiscountCircleText = styled.p<{ largeText?: boolean }>`
  color: #fff;
  font-size: ${({ largeText }) => (largeText ? '14px' : '10px')};
  font-weight: 700;
  text-align: center;
`

export const AddOnItemsIcon = styled.div`
  min-width: 32px;
  min-height: 32px;
  border-radius: 32px;
  background-color: ${({ theme }) => theme.colors.brand};
  align-items: center;
  justify-content: center;
  display: flex;
  svg {
    transform: translate(-1px, -1px);
  }
`

export const StampsAndTextContainer = styled.div``

export const DealsAndOffersContainer = styled.div<{ isBasket: boolean }>`
  display: flex;
  flex-direction: column;
  ${({ isBasket }) =>
    isBasket &&
    css`
      margin: 18px 0 8px 0;
    `};
`

export const DealsAndOffersHeader = styled.div<{ isBasket: boolean }>`
  font-size: 18px;
  font-weight: 700;
  ${({ isBasket }) =>
    !isBasket &&
    css`
      display: none;
    `};
`

export const HeaderAndMinSpendContainer = styled.div<{ isBasket: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: ${({ isBasket }) => (isBasket ? '12px' : '8px')};
`

export const MinimumSpendNeededContainer = styled.div`
  all: unset;
  height: 28px;
  border-radius: 18px;
  background-color: ${({ theme }) => theme.colors.brand};
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  display: flex;
  cursor: pointer;
`
export const MinSpendText = styled.p`
  color: white;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  align-items: center;
`

export const MinSpendTextBold = styled.p`
  color: white;
  font-size: 12px;
  font-weight: 700;
  display: flex;
  margin: 0 3px;
`
